<template>
  <div id="dataRetrieval" class="page-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      <el-breadcrumb-item>数据检索</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="yellowStyle">
      <img src="../../../assets/img/other/trumpet_icon.png" style="margin-right: 5px;">
      <span>
        检索任务单号只保留最近7日内的数据，超过7日的数据将会被清除。
      </span>
    </div>

    <div class="bigClass">
      <el-row>
        <el-col :span="6">
          <el-button type="primary" size="mini" @click="$router.push(`/retrievalTask`)">创建检索任务</el-button>
        </el-col>
        <el-col :span="18">
          <div style="float: right;">
            <span>
              创建时间：
            </span>
            <el-date-picker
              v-model="searchformDate"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              range-separator="~"
              :picker-options="pickerOptions"
              size="small"
              @change="datePicker"
              >
            </el-date-picker>
          </div>
          <div style="float: right;position: relative;margin-right: 24px;">
            <el-input v-model="number" placeholder="请输入任务单号" style="width: 320px;position: relative;" size="mini"></el-input>
            <el-button icon="el-icon-search" type="text" style="position: absolute;left: 295px;top: -6px;" @click="getList()"></el-button>

          </div>
        </el-col>
      </el-row>
    </div>

    <div class="bigClass" v-for="(item,index) in dataList">
      <div style="height: 28px;margin-bottom: 8px;">
        <div style="float: left;font-size: 16px;font-weight: 600;line-height: 28px;">
          任务单号：{{item.number}}
        </div>
        <!-- v-show="item.spider_status == 4 || "item.spider_status == 3" -->
        <el-button size="mini" style="float: right;margin-left: 8px;" type="primary" :loading="downLoading[index]" @click="download(item.id,item.platform,item.infotype,item.number,item.dataNum,index)" v-show="item.platform != 'TBTM' && item.spider_status != 2">下载数据</el-button>
        <el-button size="mini" style="float: right;margin-left: 8px;" @click="del(item.id)" v-show="item.spider_status != 3">删除任务</el-button>
      </div>
      <el-row>
        <el-col :span="8">
          <div style="margin-top: 8px;">
            平台：
            <span style="color: #999;">
              {{item.platform | platformChinese}}
            </span>
          </div>
          <div style="margin-top: 8px;">
            页数范围：
            <span style="color: #999;">
              前{{item.page}}页
            </span>
          </div>
          <div style="margin-top: 8px;">
            更新方式：
            <span style="color: #999;" v-if="item.changetime != 0">
              定时检索 {{item.changetime}}
            </span>
            <span style="color: #999;" v-else>
              即刻检索
            </span>
          </div>
          <div style="margin-top: 8px;">
            开始时间：
            <span style="color: #999;" v-if="item.spider_begintime">
              {{item.spider_begintime | fullTime}}
            </span>
            <span style="color: #999;" v-else>
              --
            </span>
          </div>
        </el-col>
        <el-col :span="8">
          <div style="margin: 8px 0;height: 22px;line-height: 22px;float: left;width: 100%;">
            <div style="float: left;">
              关键词：
            </div>
            <div style="width: 100px;float: left;">
              <div style="float: left;" v-if="item.childList">
                {{item.childList.length}}
              </div>
              <div style="float: right;color: #409eff;cursor: pointer;">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  <div v-for="n in item.childList">
                    {{n.keywordname}}
                  </div>
                  <span slot="reference">详情</span>
                </el-popover>
              </div>
            </div>
          </div>
          <div style="margin-top: 8px;">
            获取信息：
            <span style="color: #999;" v-if="item.infotype == 2">
              列表页+详情页
            </span>
            <span style="color: #999;" v-else>
              列表页
            </span>
          </div>
          <div style="margin-top: 8px;">
            创建时间：
            <span style="color: #999;">
              {{item.createtime | fullTime}}
            </span>
          </div>
          <div style="margin-top: 8px;">
            已耗时：
            <span style="color: #999;">
              {{item.timeConsuming}}
            </span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="iSty" style="margin-top: 40px;" v-show="item.spider_status == 1">
            <i class="el-icon-time" style="color: #409eff;font-size: 45px;float: left;margin-right: 16px;"></i>
            <div class="iSty">
              等待中
            </div>
          </div>

          <div class="iSty" style="margin-top: 40px;" v-show="item.spider_status == 2">
            <i class="el-icon-warning-outline" style="color: #409eff;font-size: 45px;float: left;margin-right: 16px;"></i>
            <div class="iSty">
              排队中
            </div>
          </div>

          <div class="iSty" style="margin-top: 40px;" v-show="item.spider_status == 3">
            <i class="el-icon-time" style="color: #67c23a;font-size: 45px;float: left;margin-right: 16px;"></i>
            <div class="iSty">
              进行中
            </div>
          </div>

          <div class="iSty" style="margin: 40px 0 16px 0;" v-show="item.spider_status == 4">
            <i class="el-icon-circle-check" style="color: #67c23a;font-size: 45px;float: left;margin-right: 16px;"></i>
            <div class="iSty">
              已完成
            </div>
            <div style="font-size: 14px;color: #999;width: 100%;float: left;">
              链接量（含SKU）：{{item.dataNum}}
            </div>
          </div>
          <!-- <div style="clear: both;font-size: 14px;" v-show="item.spider_status == 4">
            <span style="color: #333;">未入库主链接占比</span>
            <span style="color: #999;"> 12.24%</span>
          </div> -->

          <div class="iSty" style="margin-top: 40px;" v-show="item.spider_status == 5">
            <i class="el-icon-circle-close" style="color: red;font-size: 45px;float: left;margin-right: 16px;"></i>
            <div class="iSty">
              爬虫执行异常
            </div>
          </div>

        </el-col>
      </el-row>
    </div>
    <div style="width: 100%;text-align: center;">
      <el-button size="small" class="btnMore" @click="andMore" v-if="dataList.length == 10">加载更多...</el-button>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="deleteShow"
      width="360px" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
          <div>
            <div style="font-size: 16px;">
              你确认要删除该检索任务吗？
            </div>
            <div style="font-size: 14px;">删除后
              <span style="color: #e90e24;font-size: 14px;">
                任务计划和检索数据将被彻底删除
              </span>
            </div>
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteClassification" size="small" :loading="ficationLoading">确 定</el-button>
        <el-button @click="deleteShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="donwShow"
      width="360px" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
          <div>
            <div style="font-size: 16px;">
              当前任务检索数据量超过5万条！
            </div>
            <div style="font-size: 14px;">系统将会为你
              <span style="color: #e90e24;font-size: 14px;">
                下载前5万条数据
              </span>,剩余数据如需下载，请联系技术后台下载。
            </div>
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="litDownload" size="small">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        downLoading: [],
        dataList: [],
        pageNo: 1,
        pageSize: 10,
        number: '',
        searchformDate: [],
        deleteShow: false,
        ficationLoading: false,
        moreShow: true,
        delId: '',
        pickerOptions: {
  				shortcuts: [{
            text: '今日',
            onClick:(picker) => {
  						this.getRecentDate(picker,1);
  					}
          },{
            text: '近7日',
            onClick:(picker) => {
  						this.getRecentDate(picker,7);
  					}
          }, {
  					text: '近15日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,15);
  					}
  				}, {
  					text: '近30日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,30);
  					}
  				}, {
  					text: '近90日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,90);
  					}
  				}, {
  					text: '近365日',
  					onClick:(picker) => {
  						this.getRecentDate(picker,365);
  					}
  				}]
  			},
        downloadId: '',
        downloadPlatform: '',
        infotype: '',
        downloadNumber: '',
        donwShow: false,
        downIndex: '',
      }
    },
    // created(){
  	// 	this.getRecentDate();
  	// },
    mounted() {
      this.getList()
    },
    methods: {
      download(id,platform,infotype,number,dataNum,index) {
        console.log(index)
        this.downIndex = index
        this.downloadId = id
        this.downloadPlatform = platform
        this.infotype = infotype
        this.downloadNumber = number
        if (dataNum > 49999) {
          this.donwShow = true
        } else {
          this.litDownload()
        }
      },
      litDownload() {
        this.donwShow = false
        this.$set(this.downLoading,this.downIndex,true);
        let typeName = ''
        if (this.infotype == 2) {
          typeName = '列表页+详情页'
        } else {
          typeName = '列表页'
        }
        let downName = this.$options.filters['platformChinese'] (this.downloadPlatform) + typeName + this.downloadNumber + '.xlsx'
        let params = {
          id: this.downloadId,
          pageNo: 1,
          pageSize: 50000
        }
        fetch({
          url: "hcm/hcmKeywords/download",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 10
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", downName);
          document.body.appendChild(link);
          link.click();
          this.$set(this.downLoading,this.downIndex,false);
        });
      },
      getRecentDate(picker,n){
  			const end = new Date();
  			const start = new Date();
  			start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
  			if(picker){
  				picker.$emit('pick', [start, end]);
        }
        if (n === 1) {
          this.searchformDate[0] = end;
          this.searchformDate[1] = end;
        } else {
          this.searchformDate[0] = start;
          this.searchformDate[1] = end;
        }
  		},
      datePicker() {
        let start = this.searchformDate[0]
        let end = this.searchformDate[1]
        this.searchformDate[0] = this.$options.filters['fullTime'] (start).substring(0,10);
        this.searchformDate[1] = this.$options.filters['fullTime'] (end).substring(0,10);
        this.getList()
      },
      andMore() {
        let num = Number(this.pageSize) + 10
        this.pageSize = num
        this.getList()
      },
      getList() {
        let params={
          begintime: this.searchformDate[0],
          endtime: this.searchformDate[1],
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        if (this.number) {
          params.number = this.number
        }
        fetch({
          url: "hcm/hcmKeywords/getList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.dataList = res.data.content
            let timestamp = Date.parse(new Date());
            console.log(this.dataList)
            if (this.dataList.length > 0) {
              for (let a in this.dataList) {
                this.downLoading.push(false)
                if (this.dataList[a].spider_status == 4) {
                  let bb = this.dataList[a].updatetime - this.dataList[a].spider_begintime
                  this.dataList[a].timeConsuming = parseInt(bb/60000) + '分钟'
                } else if (this.dataList[a].spider_begintime) {
                  let cc = timestamp - this.dataList[a].spider_begintime
                  this.dataList[a].timeConsuming = parseInt(cc/60000) + '分钟'
                } else {
                  this.dataList[a].timeConsuming = '--'
                }
              }
            }
          } else {
            this.$message.error(res.message);
          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 删除赋值
      del(id) {
        this.delId = id
        this.deleteShow = true
      },
      // 删除
      deleteClassification() {
        let datas = {
          id: this.delId,
        };
        fetch({
          url: "hcm/hcmKeywords/delecthcmKeywords",
          method: "post",
          data: datas,
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            this.deleteShow = false
            this.getList()
          } else {
            this.$message.error(res.message);
          }
        });
      },
    }
  }
</script>
<style lang="scss">
#dataRetrieval {
  .yellowStyle {
    padding: 8px;
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    margin-bottom: 16px;
  }
  .bigClass {
    border-radius: 10px;
    padding: 16px;
    background-color: white;
    margin-bottom: 16px;
  }
  .iSty {
    font-size: 16px;
    line-height: 45px;
    float: left;
  }
}
</style>
